module.exports = __webpack_public_path__ + "img/divesh-pro.16e60d00.jpg";